import React from 'react'
import useModal from '../../hooks/useModal'
import ModalContent from '../Molecule/ModalContent'

const Modal = () => {
  const {
    ModalPortal,
    onClickExport,
    handleSaveClick,
    modalOpen,
    setModalOpen,
    image
  } = useModal()

  return (
    <div>
      <div className="container start"/>
      <button
        type="button"
        onClick={() =>onClickExport()}
        disabled={modalOpen}
        className='png-btn parts-name'
      >
        完成
      </button>

      { modalOpen && (
        <ModalPortal>
          <ModalContent
            handleCloseClick={() => setModalOpen(false)}
            image={image}
            handleSaveClick={handleSaveClick}
          />
        </ModalPortal>
      )}
    </div>
  )
}

export default Modal
